export default __webpack_public_path__ + "static/media/hop02.4c20c4d3.png";